// extracted by mini-css-extract-plugin
export default {"fields":"g2ir9bzSbRxFaX893Ywg"};